// ============================================
// src/components/home/HeroBadge.tsx
// ============================================
import { Box } from '@mui/material';
import { Speed } from '@mui/icons-material';

interface HeroBadgeProps {
  text: string;
  icon?: React.ReactNode;
}

export default function HeroBadge({ text, icon = <Speed sx={{ fontSize: 18 }} /> }: HeroBadgeProps) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 1,
        mb: 3,
        bgcolor: 'primary.main',
        color: 'white',
        borderRadius: 10,
        fontSize: '0.875rem',
        fontWeight: 600,
        boxShadow: '0 4px 14px 0 rgba(30, 64, 175, 0.4)',
        animation: 'pulse 2s infinite',
        '@keyframes pulse': {
          '0%, 100%': { opacity: 1 },
          '50%': { opacity: 0.85 },
        },
      }}
    >
      {icon}
      {text}
    </Box>
  );
}